import { Typography, useTheme } from '@mui/material';
import React, { useLayoutEffect } from 'react';
import { FadeLoader } from 'react-spinners';

import { registerFullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader.store';
import { FullScreenLoaderModalContainer } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader.styled';
import { TFullscreenLoaderProps } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader.types';
import { Modal } from '@/shared/components/ui/modal-controller/modal-controller.styled';

export const FullscreenLoader: React.FC<TFullscreenLoaderProps> = ({
  display = true,
  loaderText,
}) => {
  const theme = useTheme();

  useLayoutEffect(() => {
    if (!display) {
      return;
    }

    return registerFullscreenLoader();
  }, [display]);

  return (
    <Modal open={display} disableEscapeKeyDown hideBackdrop>
      <FullScreenLoaderModalContainer
        alignItems="center"
        justifyContent="center"
      >
        <FadeLoader color={theme.palette.primary.main} />
        {loaderText && <Typography>{loaderText}</Typography>}
      </FullScreenLoaderModalContainer>
    </Modal>
  );
};
